import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import CircledButton from 'common/components/buttons/CircledButton';
import CombinedAggragate from '../components/CombinedAggragate';
import RequestedValue from '../components/RequestedValue';

const DateJoined = ({ selectField, changeField, onRemove, fields, showHeader, isEditDisabled }) => {
  return (
    <Row className={'cmt-4'}>
      <Col xs={4} className="fs-12 fw-medium text-primary ">
        Minimum number of days that shall lapse between replacement of
      </Col>

      <Col xs={4}>
        <CombinedAggragate
          isEditDisabled={isEditDisabled}
          fields={fields}
          selectField={selectField}
        />
      </Col>

      <Col>
        <RequestedValue
          changeField={changeField}
          fields={fields}
          showHeader={showHeader}
          isEditDisabled={isEditDisabled}
          isDateJoined
        />
      </Col>

      {isEditDisabled ? null : (
        <Col xs="auto" className="ms-auto">
          <CircledButton
            onClick={onRemove}
            type="remove"
            className="remove-icon"
            svgStyle={{ width: 6, height: 6 }}
            style={{ width: 16, height: 16 }}
          />
        </Col>
      )}
    </Row>
  );
};

export default DateJoined;

DateJoined.propTypes = {
  selectField: PropTypes.func.isRequired,
  changeField: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  showHeader: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
  fields: PropTypes.shape({
    rank: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    second_rank: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    threshold: PropTypes.shape({ value: PropTypes.string, error: PropTypes.string }),
    type_id: PropTypes.shape({ value: PropTypes.number, error: PropTypes.string })
  })
};
